import { render, staticRenderFns } from "./SettingsLanguages.vue?vue&type=template&id=64bce86d&"
import script from "./SettingsLanguages.vue?vue&type=script&lang=js&"
export * from "./SettingsLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports